<template>
<div class="body">
  <IndexNav></IndexNav>
  <v-container fluid>
    <v-row justify="center">
      <v-col sm="12" md="6" style="align-self: center">
        <div style="width: 75% !important; margin: auto; align-self: center">
          <h1 class="text-left text-uppercase mb-16" style="color: var(--v-darkGreen-base)">Vítejte zpět</h1>
          <v-alert type="error" class="ma-0" v-if="loginError">
            Neplatné přihlašovací údaje.
          </v-alert>
          <v-alert type="error" class="ma-0" v-if="emailError">
            Registrace proběhla úspěšně, potvrďte prosím email.
          </v-alert>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            class="mt-4"
          >
            <label>Vložte prosím svůj e-mail</label>
            <v-text-field
              outlined
              color="green"
              v-model="form.email"
              :rules="[rules.required]"
              placeholder="INFO@VASEDOMENA.CZ"
              required
              class="rounded-lg"
            ></v-text-field>
            <label>Vložte prosím své heslo</label>
            <v-text-field
              class="rounded-lg"
              outlined
              color="green"
              v-model="form.password"
              :rules="[rules.required]"
              placeholder="HESLO"
              :type="show1 ? 'text' : 'password'"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show1 = !show1"
              required
            ></v-text-field>
            <div class="text-right mb-3"><router-link :to="{name: 'sendResetPasswordMail'}" >Neznám heslo :(</router-link></div>
            <v-btn
              :disabled="!valid || wait"
              color="lightGreen"
              class="mr-4 text-uppercase py-8 mb-5 btn btn-green-gradient"
              style="width: 100%; color: white !important;"
              @click.prevent="login"
            >
              Přihlásit se
            </v-btn>
          </v-form>
          <div class="mb-5 text-center" style="align-items: baseline">Nemáte účet? <router-link :to="{name: 'register'}" class="pl-2"> Zaregistrujte se</router-link> <br class="d-flex"> <span class="px-2">nebo</span> <router-link :to="{name: 'quick-register'}">Rychlá registrace</router-link></div>
          <div class="text-center"><router-link :to="{ name: 'resendEmail' }">Nepřišel aktivační odkaz? <br class="d-flex d-sm-none">Pošlete si jej znova</router-link></div>
        </div>
      </v-col>
      <v-col xs="0" sm="0" md="6" class="d-none d-sm-flex">
        <v-img src="@/assets/loginimg.jpg" class="rounded-xl" id="loginimg"></v-img>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import rules from '../../../mixins/rules'
import { mapGetters } from 'vuex'
import IndexNav from '@/views/IndexNav'

export default {
  components: { IndexNav },
  mixins: [rules],
  name: 'LoginForm',
  data () {
    return {
      show1: false,
      valid: true,
      wait: false,
      loginError: false,
      emailError: false,
      form: {
        email: '',
        password: ''
      },
      correct: true
    }
  },
  methods: {
    login () {
      this.loginError = false
      this.wait = true
      this.$http.post('/login', this.form)
        .then(response => {
          this.wait = false
          this.$store.commit('user/clearUserData')
          const userData = this.keysToCamelCase(response.data.user)
          userData.accessToken = response.data.access_token
          this.$store.commit('user/setUserData', userData)
          switch (this.currentUser.roleId) {
            case 1:
            case 2:
            case 3: this.$router.push({ name: 'admin.dashboard' }); break
            case 4: this.$router.push({ name: 'admin.delivery' }); break
            case 5: this.$router.push({ name: 'admin.personalCollection' }); break
            case 6: this.$router.push({ name: 'user.dashboard' }); break
            case 7: this.$router.push({ name: 'boarder.main' }); break
          }
        })
        .catch(err => {
          this.wait = false
          if (err.response.status === 401 || err.response.status === 400) {
            if (err.response.data.message === 'Email is not verified!') {
              this.emailError = true
              this.loginError = false
            } else {
              this.loginError = true
              this.emailError = false
            }
          }
        })
    }
  },
  created () {
    document.body.addEventListener('keypress', e => {
      if (e.code === 'Enter' && (this.valid && !this.wait)) {
        this.login()
      }
    })
  },
  computed: {
    ...mapGetters({ currentUser: 'user/currentUser' })
  }
}
</script>

<style scoped>
  #loginimg{
    height: 95vh;
  }
  .body{
    background-color: #f9f9fb !important;
    height: 100vh;
  }
  a{
    color: var(--v-lightGreen-base) !important;
    text-decoration: none;
    font-size: 0.9em;
  }
  .container{
    font-family: 'Readex Pro', sans-serif !important;
  }
  h1{
    font-family: 'Poppins', sans-serif;
  }
  label{
    color: black;
    font-weight: 500;
  }
  >>>.v-input__slot{
    background-color: white !important;
  }
  >>>input::placeholder {
    font-weight: 500 !important;
  }
  >>>.theme--light.v-input input, >>>.theme--light.v-input textarea{
    color: var(--v-darkGreen-base) !important;
  }
</style>
